// Shop piece generation

import { SHOP_SLOTS } from '../constants';

// Weighted distribution for shop piece bag
// Q:1, R:3, B:5, N:5, P:16 (over 30 total samples)
const SHOP_PIECE_BAG = Object.freeze([
  // Queens (1)
  'wQ',
  // Rooks (3)
  'wR', 'wR', 'wR',
  // Bishops (5)
  'wB', 'wB', 'wB', 'wB', 'wB',
  // Knights (5)
  'wN', 'wN', 'wN', 'wN', 'wN',
  // Pawns (16)
  'wP', 'wP', 'wP', 'wP', 'wP', 'wP', 'wP', 'wP',
  'wP', 'wP', 'wP', 'wP', 'wP', 'wP', 'wP', 'wP'
]);

/**
 * Generate a random shop with weighted piece distribution
 * 
 * @param {number} slots - Number of shop slots (default: SHOP_SLOTS)
 * @returns {Array<string>} Array of piece types (e.g., ['wP', 'wN', 'wQ', 'wB', 'wR'])
 */
export function generateShop(slots = SHOP_SLOTS) {
  const picks = [];
  for (let i = 0; i < slots; i++) {
    const idx = Math.floor(Math.random() * SHOP_PIECE_BAG.length);
    picks.push(SHOP_PIECE_BAG[idx]);
  }
  return picks;
}






